export default {
  name: "virtualWrapper",
  inject: {
    $dsfElTable: {
      default: null
    }
  },
  props: {
    fixedPosition: {
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },
  computed: {
    fixedMark() {
      return this.table.getFixed(this.fixedPosition);
    },
    data() {
      return this.$dsfElTable.data;
    },
    table() {
      return this.$dsfElTable;
    }
  },
  created() {
    this.table.$on("virtual-scroll",this.updateTranslateY);
  },
  beforeDestroy() {
    if (this.fixedMark == "main" && this.table.useVirtulScroll) {
      dsf.event.removeMouseWheelEvent(this.$el, this.onMouseWheelHandler);
    }
    this.table.$off("virtual-scroll",this.updateTranslateY);
  },
  mounted() {
    if (this.fixedMark == "main" && this.table.useVirtulScroll) {
      dsf.event.addMouseWheelEvent(this.$el, this.onMouseWheelHandler);
    }
  },
  methods: {
    updateTranslateY(){
      this.$refs.box.style.transform=`translateY(${this.unitSize(this.table.$translateY)})`
    },
    onMouseWheelHandler(event, data) {
      const virtualBox = this.table.$refs.virtualBox;
      if (Math.abs(data.spinY) > 0 && !event.shiftKey) {
        const currentScrollTop = virtualBox.scrollTop;
        if (data.pixelY < 0 && currentScrollTop !== 0) {
          event.preventDefault();
        }
        if (data.pixelY > 0 && virtualBox.scrollHeight - virtualBox.clientHeight > currentScrollTop) {
          event.preventDefault();
        }
        virtualBox.scrollTop += Math.ceil(data.pixelY / 5);
      } else {
        let direction = data.spinY > 0 ? 1 : -1;
        virtualBox.scrollLeft += Math.ceil((200 * direction) / 5);
      }
    }
  },
  render(h) {
    let width = this.table.layout.bodyWidth;
    //标识表格横向撑满屏幕,但存在纵向滚动条
    if (this.table.layout.scrollY && !this.table.layout.scrollX) {
      width = this.table.layout.bodyWidth - this.table.layout.gutterWidth;
    }
    let height = this.table.useVirtulScroll ? this.table.scrollHeight : "auto";
    return (
      <div
        class="el-table__virtual-wrapper"
        style={{
          width: this.unitSize(width),
          height: this.unitSize(height)
        }}
      >
        <div ref="box" style={{ height: this.data.length <= 0 ? "100%" : "auto" }}>
          {this?.$scopedSlots?.default?.()}
        </div>
      </div>
    );
  }
};
